<template>
  <div v-b-modal.:id="id" class="video-wrapper">
    <img :src="preview" alt />
    <button class="video-btn">
      <img src="@/assets/images/video-btn.svg" alt />
    </button>

    <b-modal size="xl" :id="id" body-class="video-body" centered hide-footer hide-header>
      <b-embed
        type="iframe"
        :src="src"
        frameborder="0"
        allowfullscreen
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      ></b-embed>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    id: String,
    preview: String
  }
};
</script>

